import * as React from 'react';

export default function TrashOutline({ className, ...props }: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      fill="none"
      className={className}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.20039 1.6001C6.89737 1.6001 6.62036 1.7713 6.48485 2.04233L5.90596 3.2001H3.20039C2.75856 3.2001 2.40039 3.55827 2.40039 4.0001C2.40039 4.44193 2.75856 4.8001 3.20039 4.8001L3.20039 12.8001C3.20039 13.6838 3.91674 14.4001 4.80039 14.4001H11.2004C12.084 14.4001 12.8004 13.6838 12.8004 12.8001V4.8001C13.2422 4.8001 13.6004 4.44193 13.6004 4.0001C13.6004 3.55827 13.2422 3.2001 12.8004 3.2001H10.0948L9.51593 2.04233C9.38042 1.7713 9.10341 1.6001 8.80039 1.6001H7.20039ZM5.60039 6.4001C5.60039 5.95827 5.95856 5.6001 6.40039 5.6001C6.84222 5.6001 7.20039 5.95827 7.20039 6.4001V11.2001C7.20039 11.6419 6.84222 12.0001 6.40039 12.0001C5.95856 12.0001 5.60039 11.6419 5.60039 11.2001V6.4001ZM9.60039 5.6001C9.15856 5.6001 8.80039 5.95827 8.80039 6.4001V11.2001C8.80039 11.6419 9.15856 12.0001 9.60039 12.0001C10.0422 12.0001 10.4004 11.6419 10.4004 11.2001V6.4001C10.4004 5.95827 10.0422 5.6001 9.60039 5.6001Z"
        fill="currentColor"
      />
    </svg>
  );
}
